import React from 'react';
import './ImageGallery.css'; // Import file SCSS/CSS

const ImageGallery = ({ images }) => {
  // Nếu không có ảnh thì hiển thị thông báo
  if (!images || images.length === 0) {
    return <p>Chưa có ảnh nào trong thư viện.</p>;
  }

  return (
    // Thêm một section bao ngoài để dễ dàng thêm padding/margin
    <section className="gallery-section wf-section">
      <div className="container"> {/* Dùng container để căn giữa và giới hạn chiều rộng nếu cần */}
        <div className="image-grid">
          {/* Lặp qua mảng ảnh và hiển thị từng ảnh */}
          {images.map((image) => (
            <div key={image.id} className="image-grid-item">
              <img src={image.src} alt={image.alt} loading="lazy" /> {/* Thêm loading="lazy" để tối ưu */}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ImageGallery;